import { sendWebsocketMessage } from '../../../../../App';

export function addAlert(data) {
  data.id = Date.now();
  const msg = {
    messageType: 'addTradePlan',
    addTradePlan: data,
  };
  sendWebsocketMessage(msg);
}
